import axios from "axios";
import posthog from "posthog-js";
import { toast } from "react-toastify";

import AuthService from "../../services/auth.service";
import CampaignService from "../../services/campaign.service";

const APP_URL = process.env.APP_URL;

export function save({
  isLoading,
  selectedSubscriptionPackage,
  code,
  activeDiet,
  searchParams,
  setIsLoading,
  handleNotfound,
  navigate,
}) {
  if (isLoading) {
    return false;
  }

  if (!selectedSubscriptionPackage || selectedSubscriptionPackage < 0) {
    toast.error("لطفا برنامه مورد نظر خود را انتخاب نمایید!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    return false;
  }

  const config = {
    headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
  };

  let body = {
    subscription_package_id: selectedSubscriptionPackage.id,
    voucher_code: code,
    diet_id: activeDiet.id,
    source: 2,
    program: searchParams.get("program"),
    intend_url:
      window.location.protocol + "//" + window.location.host + "/subscriptions",
    failed_intend_url:
      window.location.protocol + "//" + window.location.host + "/dashboard",
  };

  const campaignParameters = CampaignService.get();

  body = { ...body, ...campaignParameters };

  setIsLoading(true);

  axios
    .post(`${APP_URL}/api/v6/gateway-transactions/store`, body, config)
    .then(function (response) {
      if (response.data.message) {
        toast.loading(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }

      if (response.data.status && response.data.action) {
        if (response.data.action === "intent") {
          const payment = response.data.payment;
          if (payment) {
            function postRefId(refIdValue) {
              if (payment.method === "POST") {
                var form = document.createElement("form");
                form.setAttribute("method", payment.method);
                form.setAttribute("action", payment.action);
                form.setAttribute("target", "_self");
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("name", "RefId");
                hiddenField.setAttribute("value", refIdValue);

                form.appendChild(hiddenField);
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
              } else {
                setTimeout(() => {
                  window.location.href = payment.action;
                }, 2000);
              }
            }
            posthog?.capture("opening-payment-gatway");
            postRefId(response.data.payment.inputs.RefId);
            setIsLoading(false);
          } else {
            setTimeout(() => {
              posthog?.capture("opening-payment-gatway");
              window.location.replace(response.data.data);
            }, 2000);

            setIsLoading(false);
          }
        }
      } else {
        setIsLoading(false);
      }
    })
    .catch(function (error) {
      setIsLoading(false);

      if (!error.response) {
        toast.error("خطایی رخ داده است!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        return false;
      }

      const statusCode = error.response.status;
      switch (statusCode) {
        case 422:
          const { errors } = error.response.data;

          for (const errorsKey in errors) {
            const error = errors[errorsKey];

            toast.error(error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
          break;

        case 401:
          navigate("/auth");
          break;
        default:
          handleNotfound();

          break;
      }
    })
    .finally(() => {
      setIsLoading(false);
    });
}
